import { defineComponent } from 'vue';
import { useFetchPage } from '@/composition/fetch';
import { getCompanyPage } from '@/api/company/companyApi';
export default defineComponent({
    components: {
        Search: () => import('../components/Search.vue'),
        DataTable: () => import('../components/DataTable.vue'),
        Paging: () => import('@/components/Paging/index.vue')
    },
    setup() {
        const { state, request, changePage } = useFetchPage(getCompanyPage);
        request();
        return {
            state,
            request,
            changePage
        };
    }
});
